import { render, staticRenderFns } from "./TrainingRecordDetails.vue?vue&type=template&id=0c5c3544&scoped=true"
import script from "./TrainingRecordDetails.vue?vue&type=script&lang=ts"
export * from "./TrainingRecordDetails.vue?vue&type=script&lang=ts"
import style0 from "./TrainingRecordDetails.vue?vue&type=style&index=0&id=0c5c3544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c3544",
  null
  
)

export default component.exports